import { render, staticRenderFns } from "./gInput.vue?vue&type=template&id=a595bd30&"
import script from "./gInput.vue?vue&type=script&lang=js&"
export * from "./gInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports